const useIncidentsDataGridStyles = () => {
    return {
        incidentsGridCardStyles: {
            p: 1.5
        }
    };
};
export default useIncidentsDataGridStyles;
